<div class="ch-doc" [class.is-drag-over]="isDragOver" [class.is-disabled]="!isReady"
  [class.has-document]="hasDocument" [class.is-readonly]="readonly" (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
  <input #fileInput type="file" class="ch-doc__input" [accept]="accept" (change)="onFileSelected($event)" />

  <span class="ch-doc__icon">
    <mat-icon>{{ isUploading ? 'hourglass_top' : hasDocument ? 'task' : readonly ? 'insert_drive_file' : 'upload_file' }}</mat-icon>
  </span>

  <div class="ch-doc__text">
    <span class="ch-doc__label">{{ label }}</span>

    <span class="ch-doc__hint" *ngIf="!isReady">
      {{ readonly ? 'No vessel IMO to look up documents' : 'Enter a valid vessel IMO to attach documents' }}
    </span>
    <span class="ch-doc__hint" *ngIf="isReady && isUploading">Uploading…</span>
    <span class="ch-doc__hint" *ngIf="isReady && !isUploading && isChecking">Checking…</span>
    <button type="button" class="ch-doc__hint ch-doc__file" *ngIf="isReady && !isUploading && !isChecking && hasDocument"
      [title]="'Open ' + (storedFileName || 'document')" [disabled]="isBusy" (click)="openDocument()">
      {{ storedFileName || 'Document on file' }}
    </button>
    <span class="ch-doc__hint" *ngIf="isReady && !isUploading && !isChecking && !hasDocument && readonly">
      No document uploaded
    </span>
    <span class="ch-doc__hint" *ngIf="isReady && !isUploading && !isChecking && !hasDocument && !readonly">
      Drag &amp; drop a file here or
      <button type="button" class="ch-doc__link" (click)="fileInput.click()">browse</button>
    </span>
  </div>

  <div class="ch-doc__actions" *ngIf="isReady && hasDocument && !isUploading">
    <button type="button" class="ch-doc__btn" (click)="openDocument()" [disabled]="isBusy"
      title="Open the uploaded document">
      <mat-icon>{{ isOpening ? 'hourglass_empty' : 'visibility' }}</mat-icon>
      <span>{{ isOpening ? 'Opening…' : 'View' }}</span>
    </button>
    <button type="button" class="ch-doc__btn ch-doc__btn--ghost" *ngIf="!readonly" (click)="fileInput.click()"
      [disabled]="isBusy" title="Replace with a new file (or drop one here)">
      <mat-icon>autorenew</mat-icon>
      <span>Replace</span>
    </button>
  </div>
</div>
